import React, { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { TEST_ACCOUNT_TAG_ID } from '@scale/shared/defaults';

type CTA = {
  label: string;
  onClick: () => void;
};

export interface BannerInfo {
  bannerMessage: string;
  bannerSubtitle: string;
  bannerType: string;
  cta?: CTA;
}

export interface IOutlierContext {
  user:
    | (IUserJson & {
        isTestAccount?: boolean;
      })
    | undefined;
  isManageAccountModalOpen: boolean;
  setIsManageAccountModalOpen: Dispatch<SetStateAction<boolean>>;
  isPayEducationModalOpen: boolean;
  setIsPayEducationModalOpen: Dispatch<SetStateAction<boolean>>;
  bannersInfo: BannerInfo[];
  setBannersInfo: Dispatch<SetStateAction<BannerInfo[]>>;
}

const OutlierContext = createContext<IOutlierContext>({
  user: undefined,
  isManageAccountModalOpen: false,
  setIsManageAccountModalOpen: (_: SetStateAction<boolean>) => {},
  isPayEducationModalOpen: false,
  setIsPayEducationModalOpen: (_: SetStateAction<boolean>) => {},
  bannersInfo: [],
  setBannersInfo: (_: SetStateAction<BannerInfo[]>) => {},
});

export const useOutlierContext = () => useContext(OutlierContext);

export const OutlierContextProvider = ({
  children,
  otherValues,
}: {
  children: React.ReactNode;
  otherValues: IOutlierContext;
}) => {
  if (
    otherValues.user?.tags &&
    (otherValues.user?.tags as string[])?.includes(TEST_ACCOUNT_TAG_ID)
  ) {
    otherValues.user.isTestAccount = true;
  }
  return (
    <OutlierContext.Provider
      value={{
        ...otherValues,
      }}
    >
      {children}
    </OutlierContext.Provider>
  );
};
